import React, { FC } from "react";
import type { UniversalPaymentAccountConfigurationAndStructureProps } from "@/types";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const UniversalPaymentAccountConfigurationAndStructure: FC<
  UniversalPaymentAccountConfigurationAndStructureProps
> = ({ content, cover }) => {
  return (
    <section className="universalPaymentAccountConfigurationAndStructure">
      <div className="wrapper">
        <TextCols content={content} />
      </div>
      <div className="wrapper wrapper_lg">
        {cover.file?.url && (
          <Image
            className="universalPaymentAccountConfigurationAndStructure--cover"
            src={cover as any}
            alt={cover.title}
            animateInView
          />
        )}
      </div>
    </section>
  );
};
